import { render } from "./Gallery.vue?vue&type=template&id=0eb7c44a&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import "./Gallery.vue?vue&type=style&index=0&id=0eb7c44a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0eb7c44a"

export default script